<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-text style="height: 300px;">
          <v-radio-group
            v-model="reasonKey"
            column
          >
            <v-radio
            v-for="(reason, index) in reasons"
            :key="index"
            :value="index">
              <template v-slot:label>
                <div align="center">{{ reason.law }} <br> 
                <strong>Član {{ reason.article }} <br> 
                Stav {{ reason.paragraph }} </strong> <br> 
                {{ reason.text}}
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            Zatvori
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click.stop="SaveReasonKey"
          >
            Izaberi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    data () {
      return {
        reasons: [],
        reasonKey: "",
        dialog: this.$parent.showExamptionReason,
      }
    },
    mounted() {
      this.getTaxExemptionReasons();
    },
    methods: {
      getTaxExemptionReasons() {
        this.axios.get('InvoiceUtilities/GetTaxExemptionReasons').then((response) => {
          this.reasons = response.data;
        })
        .catch(err => console.log(err));
      }, 
      SaveReasonKey() {
        this.$parent.newInvoice.taxExemptionReason = this.reasons[this.reasonKey]
        this.$parent.showExamptionReason = false
      },
      closeDialog() {
        this.$parent.cbVat = ""
        this.$parent.showExamptionReasonNumber = false
        this.$parent.showExamptionReason = false
      }
    }
  }
</script>